import script from "./InputListCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./InputListCheck.vue?vue&type=script&setup=true&lang=js"

import "./InputListCheck.vue?vue&type=style&index=0&id=265a4c60&lang=scss"

const __exports__ = script;

export default __exports__